import React, { useState, useEffect } from 'react';

const heroImages = [
  {
    src: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1775241419265_384d50a9.jpg',
    alt: 'Turquoise waters and white sand of the Albanian Riviera — luxury Albania travel destination with Mediterranean coastline',
  },
  {
    src: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776973064723_882c03d8.jpg',
    alt: 'Aerial view of the Albanian Riviera near Ksamil and Saranda — turquoise Ionian Sea, limestone cliffs, and hidden coves on Albania\'s Mediterranean coast',
  },
  {
    src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=2000&q=80',
    alt: 'Snow-capped peaks and emerald valleys of the Albanian Alps (Accursed Mountains) — Theth and Valbona hiking',
  },
];


const heroTexts = [
  { title: 'Discover\nAlbania', subtitle: 'Europe\'s last secret — where ancient heritage meets pristine Mediterranean shores' },
  { title: 'The Albanian\nRiviera Awaits', subtitle: 'Crystal waters, hidden coves, and untouched coastlines that rival the world\'s finest' },
  { title: 'Into the\nAccursed Mountains', subtitle: 'Dramatic alpine peaks, emerald valleys, and legendary Albanian hospitality' },
];


const HeroSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % heroImages.length);
        setIsTransitioning(false);
      }, 800);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    if (index === currentSlide) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsTransitioning(false);
    }, 800);
  };

  const scrollToDestinations = () => {
    const el = document.getElementById('destinations');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPlan = () => {
    const el = document.getElementById('plan-journey');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Images */}
      {heroImages.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={img.src}
            alt={img.alt}
            className="w-full h-full object-cover"
            loading={index === 0 ? 'eager' : 'lazy'}
            fetchPriority={index === 0 ? 'high' : 'auto'}
          />

        </div>
      ))}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6">
        <div className={`transition-all duration-700 ${isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}>
          {/* Decorative line */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-12 h-[1px] bg-[#C9A961]" />
            <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">
              Zera Travel — Albania
            </span>
            <div className="w-12 h-[1px] bg-[#C9A961]" />
          </div>

          {/* Title */}
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-light text-white leading-[1.1] whitespace-pre-line mb-6">
            {heroTexts[currentSlide].title}
          </h1>

          {/* Subtitle */}
          <p className="font-sans text-sm md:text-base font-light text-white/80 max-w-xl mx-auto tracking-wide leading-relaxed mb-10">
            {heroTexts[currentSlide].subtitle}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={scrollToDestinations}
              className="font-sans text-[11px] tracking-[0.25em] uppercase px-10 py-4 bg-[#C9A961] text-white hover:bg-[#b8944d] transition-all duration-300"
            >
              Explore Albania
            </button>
            <button
              onClick={scrollToPlan}
              className="font-sans text-[11px] tracking-[0.25em] uppercase px-10 py-4 border border-white/50 text-white hover:bg-white/10 transition-all duration-300"
            >
              Plan Your Journey
            </button>
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-3">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`transition-all duration-500 ${
                index === currentSlide
                  ? 'w-10 h-[2px] bg-[#C9A961]'
                  : 'w-6 h-[2px] bg-white/40 hover:bg-white/60'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-12 right-8 hidden lg:flex flex-col items-center gap-2">
          <span className="font-sans text-[9px] tracking-[0.2em] uppercase text-white/50 [writing-mode:vertical-lr]">
            Scroll
          </span>
          <div className="w-[1px] h-12 bg-gradient-to-b from-white/50 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
